module.exports = __webpack_public_path__ + "static/media/download.1b8207d8.svg";